import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { routes } from './account-first-login.routes';
import { SSOAccountFirstLoginFormOTPService } from './account-first-login-otp.service';

@NgModule({
  declarations: [],
  providers: [SSOAccountFirstLoginFormOTPService],
  imports: [ReactiveFormsModule, RouterModule.forChild(routes)],
})
export class SSOVerifyAccountFirstLoginModule { }
